import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CanonicalUrl = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip canonical URLs and robots meta for admin routes
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Remove existing canonical link if any
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Remove existing robots meta if any
    const existingRobots = document.querySelector('meta[name="robots"]');
    if (existingRobots) {
      existingRobots.remove();
    }

    // Create new canonical link
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `${window.location.origin}${location.pathname}`;
    
    // Add to head
    document.head.appendChild(canonical);

    // Create robots meta tag
    const robots = document.createElement('meta');
    robots.name = 'robots';
    
    // Check if it's a 404 page (custom 404 route)
    const is404Page = location.pathname === '/404';
    
    if (is404Page) {
      robots.content = 'noindex, nofollow';
    } else {
      robots.content = 'index, follow';
    }
    
    // Add to head
    document.head.appendChild(robots);

    // Cleanup function
    return () => {
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.remove();
      }
      const robotsMeta = document.querySelector('meta[name="robots"]');
      if (robotsMeta) {
        robotsMeta.remove();
      }
    };
  }, [location]);

  return null;
};

export default CanonicalUrl;
